export const b = [
        {
            value: 'cd19',
            label: 'CD19',
            select_value: 'select_cd19'
        },
        {
            value: 'cd20',
            label: 'CD20',
            select_value: 'select_cd20'
        },
        {
            value: 'cd22',
            label: 'CD22',
            select_value: 'select_cd22'
        },
        {
            value: 'cd79a',
            label: 'CD79a',
            select_value: 'select_cd79a'
        },
        {
            value: 'cyu',
            label: 'Cyμ',
            select_value: 'select_cyu'
        },
        {
            value: 'cd10',
            label: 'CD10',
            select_value: 'select_cd10'
        },
        {
            value: 'bcd34',
            label: 'CD34',
            select_value: 'select_bcd34'
        },
        {
            value: 'btdt',
            label: 'TdT',
            select_value: 'select_btdt'
        },
    ]
export const t = [
        {
            value: 'ccd3',
            label: 'cCD3',
            select_value: 'select_ccd3'
        },
        {
            value: 'cd4',
            label: 'CD4',
            select_value: 'select_cd4'
        },
        {
            value: 'cd8',
            label: 'CD8',
            select_value: 'select_cd8'
        },
        {
            value: 'cd5',
            label: 'CD5',
            select_value: 'select_cd5'
        },
        {
            value: 'cd7',
            label: 'CD7',
            select_value: 'select_cd7'
        },
        {
            value: 'tdt',
            label: 'TdT',
            select_value: 'select_tdt'
        },
        {
            value: 'cd1a',
            label: 'CD1a',
            select_value: 'select_cd1a'
        },
        {
            value: 'cd2',
            label: 'CD2',
            select_value: 'select_cd2'
        },
        {
            value: 'cd56',
            label: 'CD56',
            select_value: 'select_cd56'
        }
    ]
export const s = [
    {
        value: 'cd13',
        label: 'CD13',
        select_value: 'select_cd13'
    },
    {
        value: 'cd33',
        label: 'CD33',
        select_value: 'select_cd33'
    },
    {
        value: 'mpo',
        label: 'MPO',
        select_value: 'select_mpo'
    },
    {
        value: 'cd117',
        label: 'CD117',
        select_value: 'select_cd117'
    },
    {
        value: 'cd34',
        label: 'CD34',
        select_value: 'select_cd34'
    },
    {
        value: 'cd11b',
        label: 'CD11b',
        select_value: 'select_cd11b'
    },
    {
        value: 'cd14',
        label: 'CD14',
        select_value: 'select_cd14'
    },
    {
        value: 'cd15',
        label: 'CD15',
        select_value: 'select_cd15'
    },
    {
        value: 'hla_dr',
        label: 'HLA-DR',
        select_value: 'select_hla_dr'
    },
    {
        value: 'gcd64',
        label: 'CD64',
        select_value: 'select_gcd64'
    },
]